export enum NewsFlashTarget {
    Link = 'Link',
    Page = 'Page',
    None = 'None'
}
